import { useMemo } from "react";
import { sharedEnvironment } from "../../config";
import { useAuth } from "../../infra";
import { useLocaleStore, useDeveloperToolsStore } from "../../presentation";
import { configureApi } from "./index";

export const useApi = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth();
  const { locale } = useLocaleStore();
  const developerToolsStore = useDeveloperToolsStore();

  const apiConfigCreation = useMemo(
    () => ({
      baseUrl: sharedEnvironment.apiBaseUrl,
      getAccessToken: isAuthenticated ? getAccessTokenSilently : undefined,
      locale,
      cmsAccessToken:
        developerToolsStore.useCmsPreview && sharedEnvironment.cmsPreviewAccessToken
          ? sharedEnvironment.cmsPreviewAccessToken
          : sharedEnvironment.cmsAccessToken,
      cmsVersion:
        developerToolsStore.useCmsPreview && sharedEnvironment.cmsPreviewAccessToken
          ? "draft"
          : sharedEnvironment.cmsVersion,
      localCms: sharedEnvironment.localCms,
      cmsLinkWithEnv: !developerToolsStore.useCmsPreview ? sharedEnvironment.cmsLinkWithEnv : undefined,
    }),
    [locale, getAccessTokenSilently, isAuthenticated, developerToolsStore.useCmsPreview],
  );

  const api = useMemo(() => configureApi(apiConfigCreation), [apiConfigCreation]);

  return { api };
};
